import * as React from 'react'
const CheckCircleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.115 8.73 9.36 4.485l-.69-.675-3.555 3.555-1.8-1.8-.675.675 2.475 2.49ZM6 12c-.82 0-1.595-.158-2.325-.473a6.086 6.086 0 0 1-1.912-1.29 6.086 6.086 0 0 1-1.29-1.912A5.806 5.806 0 0 1 0 6c0-.83.158-1.61.472-2.34a5.996 5.996 0 0 1 1.29-1.905A6.15 6.15 0 0 1 3.675.473 5.806 5.806 0 0 1 6 0c.83 0 1.61.158 2.34.472a6.06 6.06 0 0 1 1.905 1.283 6.06 6.06 0 0 1 1.283 1.905C11.841 4.39 12 5.17 12 6c0 .82-.158 1.595-.473 2.325a6.15 6.15 0 0 1-1.282 1.913 5.996 5.996 0 0 1-1.905 1.29C7.61 11.841 6.83 12 6 12Z"
    />
  </svg>
)
export default CheckCircleIcon
